export interface QueueDurationItem {
  render_id: string;
  output_seconds?: number | null;
  estimated_duration_minutes?: number | null;
}

export const STORY_QUEUE_MAX = 6;

export function toggleQueuedRender(queue: string[], renderId: string): string[] {
  if (queue.includes(renderId)) return queue.filter((id) => id !== renderId);
  if (queue.length >= STORY_QUEUE_MAX) return queue;
  return [...queue, renderId];
}

export function moveQueuedRender(
  queue: string[],
  renderId: string,
  direction: -1 | 1
): string[] {
  const currentIndex = queue.indexOf(renderId);
  const nextIndex = currentIndex + direction;
  if (
    currentIndex < 0
    || nextIndex < 0
    || nextIndex >= queue.length
  ) return queue;

  const next = [...queue];
  [next[currentIndex], next[nextIndex]] = [next[nextIndex], next[currentIndex]];
  return next;
}

export function queuedDurationMinutes(
  queue: string[],
  renders: QueueDurationItem[]
): number {
  const byId = new Map(renders.map((render) => [render.render_id, render]));
  return queue.reduce((total, renderId) => {
    const render = byId.get(renderId);
    if (!render) return total;
    if (render.output_seconds && render.output_seconds > 0) {
      return total + render.output_seconds / 60;
    }
    return total + Math.max(0, render.estimated_duration_minutes || 0);
  }, 0);
}
